



































































































































































































import { Component, Watch, Vue,Prop } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import SubsidiaryLedgerVue from "./SubsidiaryLedger.vue";
import BalanceVue from "./Balance.vue";
import BalanceSheetVue from "./BalanceSheet.vue";
import SubjectVue from "./Subject.vue";
import VoucherListVue from "./VoucherList.vue";
import FixedAssetVue from "./FixedAsset.vue";
import { mapGetters, mapActions } from "vuex";
export interface CloseObject {
    startTime: number;
    endTime: number;
    periods: MonthSelector.Period[];
}
@Component({
    ...mapGetters(["accountBook"]),
    ...mapActions(["setClosePeriod"]),
    components: {
        "month-selector": MonthSelectorVue,
        "subsisiary-dialog": SubsidiaryLedgerVue,
        "balance-dialog": BalanceVue,
        "balanceSheet-dialog": BalanceSheetVue,
        "subject-dialog": SubjectVue,
        "voucher-dialog": VoucherListVue,
        "fixed-dialog": FixedAssetVue,
    },
})
export default class Closing extends Vue {
    @Prop({ type: Object})
	closeData!: any;
    @Prop({ type: Boolean, default: false })
    isDialog?: boolean;
    subjectVal: Subject.Subject | null = null;
    currentView: string = ""; //跳转各个页面的地址
    showDailog: boolean = false; //是否打开弹窗
    //显示按钮情况
    showCheck: boolean = true; //是否显示  马上检查
    showReCheck: boolean = false; //是否显示  重新检查
    showAccounted: boolean = false; //是否显示  继续结账 不结账
    promptMessage: string = "";
    defPromptMessage: string = ""; //初始标题
    //是否已结账
    isaccounted: number = 0;
    //结账日期
    closingPeriod: string = "";
    //改变时间
    period: string = ""; // 日期
    //默认为检查情况下，页面显示
    closingInfo: Closing.Closing[] = [];
    //结账日期
    closePeriod: string = "";
    mounted() {
        if(!this.isDialog)this.getData();
        else{
            this.resetAll()
            if (
                    this.closeData.qcbalance == false ||
                    this.closeData.isSheetBalance == false ||
                    this.closeData.isBreak
                ) {
                    this.showReCheck = true;
                } else {
                    this.showAccounted = true;
                }
                this.showCheck = false;
                let period = this.period.toString();
                let month = Number(period.substring(4));
                this.promptMessage = month + "月账表完成检查！";
                this.closingInfo[1].status =
                    "共有" +
                    this.closeData.capitalSum +
                    "项类目，其中" +
                    this.closeData.capitalNum +
                    "项类目有风险";
                this.closingInfo[2].status =
                    "共有" +
                    this.closeData.endSum +
                    "项类目，其中" +
                    this.closeData.endNum +
                    "项类目有风险";
                this.closingInfo[3].status =
                    "共有" +
                    this.closeData.delaySum +
                    "项类目，其中" +
                    this.closeData.delayNum +
                    "项类目有风险";
                this.closingInfo[0].status =
                    "共有" +
                    this.closeData.controlSum +
                    "项类目，其中" +
                    this.closeData.controlNum +
                    "项类目有风险";
                this.closingInfo[4].status = "共有0项类目，其中0项类目有风险";
                this.closingInfo[6].status =
                    "共有" +
                    this.closeData.otherSum +
                    "项类目，其中" +
                    this.closeData.otherNum +
                    "项类目有风险";

                if (this.closeData.incomeControl.length > 0) {
                    this.closingInfo[5].status =
                        "共有" +
                        this.closeData.incomeControlSum +
                        "项类目，其中" +
                        this.closeData.incomeControlNum +
                        "项类目有风险";
                } else {
                    this.closingInfo[5].status =
                        "共有0项类目，其中0项类目有风险";
                }

                this.closingInfo[1].riskItem = this.closeData.capitalNum;
                this.closingInfo[2].riskItem = this.closeData.endNum;
                this.closingInfo[3].riskItem = this.closeData.delayNum;
                this.closingInfo[0].riskItem = this.closeData.controlNum;
                this.closingInfo[4].riskItem = 0;
                this.closingInfo[6].riskItem = this.closeData.otherNum;
                this.closingInfo[5].riskItem = this.closeData.incomeControlNum;

                this.closingInfo[1].innerData = this.closeData.capitalBalances;
                this.closingInfo[2].innerData = this.closeData.endCloses;
                this.closingInfo[3].innerData = this.closeData.delayAccounts;
                this.closingInfo[0].innerData = this.closeData.controls;
                this.closingInfo[6].innerData = this.closeData.otherExceptions;
                this.closingInfo[5].innerData = this.closeData.incomeControl;
        }
    }

    changeDate(date: string) {
        this.period = date;
        if (Number(date) <= Number(this.closePeriod)) {
            this.isaccounted = 1;
        } else {
            this.isaccounted = 0;
        }
        this.resetAll();
    }
    // 获取初始数据
    closeObj: CloseObject | null = null; // 保存日期列表
    async getData() {
        await Vue.axios
            .get("periods/" + this.$store.state.accountBook.id + "/findclose")
            .then((res) => {
                this.promptMessage = res.data.PromptMessage;
                this.defPromptMessage = res.data.PromptMessage;
                this.closePeriod = res.data.closePeriod;
                this.closeObj = res.data;
                this.$store.dispatch("setClosePeriod", this.closePeriod);
                this.$store.dispatch(
                    "changeCurrentPeriod",
                    res.data.endPeriod
                );
            });
    }
    // 检查后获取数据
    fetchData() {
        Vue.axios
            .post(`close/check/finddetail`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period,
            })
            .then((res) => {
                if (
                    res.data.qcbalance == false ||
                    res.data.isSheetBalance == false ||
                    res.data.isBreak
                ) {
                    this.showReCheck = true;
                } else {
                    this.showAccounted = true;
                }
                this.showCheck = false;
                let period = this.period.toString();
                let month = Number(period.substring(4));
                this.promptMessage = month + "月账表完成检查！";
                this.closingInfo[1].status =
                    "共有" +
                    res.data.capitalSum +
                    "项类目，其中" +
                    res.data.capitalNum +
                    "项类目有风险";
                this.closingInfo[2].status =
                    "共有" +
                    res.data.endSum +
                    "项类目，其中" +
                    res.data.endNum +
                    "项类目有风险";
                this.closingInfo[3].status =
                    "共有" +
                    res.data.delaySum +
                    "项类目，其中" +
                    res.data.delayNum +
                    "项类目有风险";
                this.closingInfo[0].status =
                    "共有" +
                    res.data.controlSum +
                    "项类目，其中" +
                    res.data.controlNum +
                    "项类目有风险";
                this.closingInfo[4].status = "共有0项类目，其中0项类目有风险";
                this.closingInfo[6].status =
                    "共有" +
                    res.data.otherSum +
                    "项类目，其中" +
                    res.data.otherNum +
                    "项类目有风险";

                if (res.data.incomeControl.length > 0) {
                    this.closingInfo[5].status =
                        "共有" +
                        res.data.incomeControlSum +
                        "项类目，其中" +
                        res.data.incomeControlNum +
                        "项类目有风险";
                } else {
                    this.closingInfo[5].status =
                        "共有0项类目，其中0项类目有风险";
                }

                this.closingInfo[1].riskItem = res.data.capitalNum;
                this.closingInfo[2].riskItem = res.data.endNum;
                this.closingInfo[3].riskItem = res.data.delayNum;
                this.closingInfo[0].riskItem = res.data.controlNum;
                this.closingInfo[4].riskItem = 0;
                this.closingInfo[6].riskItem = res.data.otherNum;
                this.closingInfo[5].riskItem = res.data.incomeControlNum;

                this.closingInfo[1].innerData = res.data.capitalBalances;
                this.closingInfo[2].innerData = res.data.endCloses;
                this.closingInfo[3].innerData = res.data.delayAccounts;
                this.closingInfo[0].innerData = res.data.controls;
                this.closingInfo[6].innerData = res.data.otherExceptions;
                this.closingInfo[5].innerData = res.data.incomeControl;
            });
    }
    // 检查
    checkClosing() {
        this.showReCheck = false;
        this.showAccounted = false;
        this.fetchData();
    }
    // 继续结账
    closingAccount() {
        Vue.axios
            .post(`close/accountbook`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period,
            })
            .then((res) => {
                let period = this.period;
                this.$store.dispatch("setClosePeriod", this.period);
                this.$notify({
                    type: "success",
                    title: "成功",
                    message: "结账成功！",
                    duration: 500,
                });
                let selector: any = this.$refs.monthSelector;
                selector.getPeriods();
                this.resetAll();
                this.getData();
                // let endPeriod: Date = new Date(
                //     this.period.substring(0, 4) + "-" + this.period.substring(4)
                // );
                // let end = this.$utils.dateAdd(endPeriod, "m", 1);
                // this.$store.dispatch(
                //     "changeCurrentPeriod",
                //     this.$utils.simpleDateFormat(end, "m")
                // );
                if (this.$store.state.env !== "jzs") this.$emit("showPrint", this.$utils.strToDate(period));
            });
    }
    // 不结账
    quitAccount() {
        this.resetAll();
    }
    // 反结账
    overCheck() {
        console.log(this.period);
        Vue.axios
            .post(`close/accountbook/reverse`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period,
            })
            .then((res) => {
                this.$store.dispatch("setClosePeriod", null);
                let selector: any = this.$refs.monthSelector;
                selector.getPeriods();
                this.isaccounted = 0;
                this.resetAll();
                this.getData();
            });
    }

    //点击展示隐藏类别详细
    showDefInner(index: number, e: any) {
        if (this.closingInfo[index].showInner == true) {
            this.closingInfo[index].showInner = false;
            e.currentTarget.setAttribute("class", "el-icon-arrow-right");
            let eleTipIco: any = e.currentTarget.parentNode.querySelector(
                ".tipIco"
            );
            if (eleTipIco) {
                eleTipIco.style.display = "inline-block";
            }
        } else {
            this.closingInfo[index].showInner = true;
            e.currentTarget.setAttribute("class", "el-icon-arrow-down");
            let eleTipIco: any = e.currentTarget.parentNode.querySelector(
                ".tipIco"
            );
            if (eleTipIco) {
                eleTipIco.style.display = "none";
            }
        }
    }

    //到其他页面的弹窗
    subsidiaryDate: Date[] = []; //明细账月份
    goToPage(inner: Closing.InnerData) {
        if (inner.pageType != 0) {
            let subject: Subject.Subject = {
                id: inner.subjectId,
                no: inner.no,
                longText: inner.text,
                measuringUnit: null,
                dimAccountType: null,
                dimAccountTypes: [],
                currSymbol: null,
            };
            let period = this.period.toString();
            let subData = new Date(
                period.substring(0, 4) + "-" + period.substring(4)
            );
            // //跳转到明细账
            if (inner.pageType == 1) {
                this.subsidiaryDate = [subData, subData];
                this.subjectVal = subject;
                this.currentView = "subsisiary-dialog";
                this.showDailog = true;
            }
            //跳转到余额表
            if (inner.pageType == 2) {
                this.subsidiaryDate = [subData, subData];
                this.currentView = "balance-dialog";
                this.showDailog = true;
            }
            //跳转到资产负债表
            if (inner.pageType == 5) {
                this.subsidiaryDate = [subData];
                this.currentView = "balanceSheet-dialog";
                this.showDailog = true;
            }
            // 跳转到科目期初
            if (inner.pageType == 3) {
                this.subsidiaryDate = [subData];
                this.currentView = "subject-dialog";
                this.showDailog = true;
            }
            // 跳转凭证列表
            if (inner.pageType == 6) {
                this.subsidiaryDate = [subData];
                this.currentView = "voucher-dialog";
                this.showDailog = true;
            }
            // 跳转固定资产
            if (inner.pageType == 4) {
                this.subsidiaryDate = [subData];
                this.currentView = "fixed-dialog";
                this.showDailog = true;
            }
        }
    }
    // 弹窗关闭
    closeDialog() {
        this.currentView = "";
        this.subsidiaryDate = [];
        this.subjectVal = null;
        this.showDailog = false;
    }

    // 重置数据
    resetAll() {
        this.promptMessage = this.defPromptMessage;
        this.closingInfo = [
            {
                icoName: "feeControl",
                icoScale: 4.7,
                name: "费用控制及纳税调整",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "rmb",
                icoScale: 4.8,
                name: "资产类科目余额",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "adjusting",
                icoScale: 4.8,
                name: "期末结转",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "oneyear",
                icoScale: 4.8,
                name: "往来挂账超过一年",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "tactical",
                icoScale: 4.65,
                name: "报税与账不一致",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "incomeControl",
                icoScale: 4.6,
                name: "收入控制",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
            {
                icoName: "otherClosing",
                icoScale: 4.8,
                name: "其他异常",
                status: "此条目尚未检查",
                showInner: true,
                riskItem: 0,
                innerData: [],
            },
        ];
        this.showCheck = true;
        this.showReCheck = false;
        this.showAccounted = false;
    }
}
